import { BybButton } from "@Components/common/byb-ds";
import BybMedalElement from "@Components/common/byb-ds/byb-medal-element";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import { useCareerContext } from "@Context/game/career/career-context";
import { Leagues } from "@Enums";
import useI18n from "@i18n";
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogContentText, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CareerLeagueChangeDialog = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const { modalMessage, leagueChange, league, division, setModalMessage } = useCareerContext();

  if (!league || !division) return null;

  return (
    <Dialog
      open={!!modalMessage}
      onClose={() => setModalMessage("")}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          background: theme.palette.dsSurface.v100,
          borderRadius: theme.spacing(3),
          overflow: "hidden",
          padding: theme.spacing(4),
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center" }}>
        {leagueChange && (
          <Stack>
            <Typography variant="text9xl700" color="dsBase.v200">
              {i18n(`career.${leagueChange}.title`)}
            </Typography>
            <Typography
              variant="text5xl500"
              color="dsBase.v200"
              sx={{
                marginTop: theme.spacing(4),
                marginBottom: "-16px",
              }}
            >
              {i18n(`career.${leagueChange}.subtitle`)}
            </Typography>
            <Box width="100%" display="flex" justifyContent="center" marginTop="36px">
              {league ? <BybMedalElement league={league.name as Leagues} size={league.name === Leagues.CHAMPIONS ? 24 : 18} /> : <CircularProgress />}
            </Box>
          </Stack>
        )}
        <DialogContentText id="alert-dialog-description" sx={{ marginTop: theme.spacing(3) }}>
          <Typography variant="text8xl700" color="dsBase.v200" textTransform="uppercase">
            {i18n(`league.${league.name}.name`)}
          </Typography>
          <Typography variant="subtitle1" color="dsNeutral.v300" sx={{ fontSize: "26px", textAlign: "center" }}>
            {i18n("division.specific", { division: division.name })}
          </Typography>
          <Typography
            color="dsNeutral.v300"
            sx={{
              fontSize: "18px",
              whiteSpace: "pre-line",
              textAlign: "center",
              fontWeight: "600",
              marginTop: "30px",
            }}
          >
            {modalMessage}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <Box width="100%" textAlign="center" marginTop="8px" marginBottom="32px">
        <HapticsButtonWrapper>
          <Button onClick={() => setModalMessage("")} autoFocus sx={{ width: theme.spacing(25) }}>
            {i18n("continue")}
          </Button>
        </HapticsButtonWrapper>
      </Box>
    </Dialog>
  );
};

export default CareerLeagueChangeDialog;
